<script>
    export let isMuted;
</script>

{#if isMuted}
    <i class="fa-thin fa-microphone-slash red"></i>
{:else}
    <i class="fa-thin fa-microphone"></i>
{/if}

<style lang="scss">  
  .red {
    color: red;
  }
</style>
